export default "__VITE_PUBLIC_ASSET__5b291d1b__"